export default __webpack_public_path__ + "static/media/sorting.dfde4923.gif";